export type HapticKind = 'move' | 'capture' | 'illegal' | 'select' | 'end'

const PATTERNS: Readonly<Record<HapticKind, number | readonly number[]>> = {
  select: 6,
  move: 12,
  capture: 26,
  // Two short buzzes read as refusal; one long one reads as an error.
  illegal: [18, 40, 18],
  end: [30, 60, 30],
}

const STORAGE_KEY = 'chess:haptics'

let enabled = ((): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== '0'
  } catch {
    return true
  }
})()

/**
 * Whether this device can do anything at all.
 *
 * Android Chrome implements the Vibration API; **iOS Safari does not**, and no
 * amount of feature-flagging changes that — an iPhone will feel nothing here
 * short of wrapping the app natively. Worth stating plainly rather than
 * shipping a setting that silently does nothing for half the users.
 */
export const hapticsSupported = (): boolean =>
  typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function'

export const hapticsEnabled = (): boolean => enabled

export const setHapticsEnabled = (value: boolean): void => {
  enabled = value
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0')
  } catch {
    /* Private browsing. */
  }
}

export const vibrate = (kind: HapticKind): void => {
  if (!enabled || !hapticsSupported()) return
  try {
    navigator.vibrate(PATTERNS[kind] as number | number[])
  } catch {
    /* Some browsers throw when the page is not visible. Nothing to do. */
  }
}
